import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ButtonItem from '../components/ButtonItem';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { GENRES } from '../data/genres';

function SongViewPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [songs, setSongs] = useState([]);

  const params = new URLSearchParams(location.search);
  const page = params.get('page');
  const search = params.get('search');


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/song/${id}`
        );
        setSongs(response.data);
      } catch (error) {
        console.error('서버 접속 에러:', error);
      }
    };
    fetchData();
  }, [id]);

  const deletesong = async () => {
    if (window.confirm('곡를 삭제하시겠습니까?')) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_URL}/song/${id}`);
        if (window.confirm('곡을 삭제하였습니다.')) {
          window.location.href = '/Songs';
        }
      } catch (error) {
        alert(error.response?.data?.errorMessage);
      }
    }
  };

  return (
    <>
        <div className="flex mb-8 justify-center items-center">
          <h1 className="text-xl sm:text-2xl font-bold">곡 상세정보</h1>
        </div>

        <div className="space-y-6 max-w-2xl mx-auto">
          {/* 앨범명 */}
          <div>
            <label className="block font-semibold mb-1">앨범명</label>
            <input
              type="text"
              value={songs.album?.nameKr || ''}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
              readOnly
            />
          </div>

          {/* 앨범 아티스트 */}
          <div>
            <label className="block font-semibold mb-1">앨범 아티스트</label>
            <input
              type="text"
              value={songs.album?.artist?.nameKr || ''}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
              readOnly
            />
          </div>

          {/* 음원파일 업로드 */}
          <div>
            <label className="block font-semibold mb-1">음원듣기</label>
            {/* 기존 파일 미리듣기 (새 파일 없을 때만) */}
            {songs.fileUrl && (
              <div className="mt-2">
                <audio controls src={songs.fileUrl} style={{ width: '100%' }} />
              </div>
            )}
          </div>

          {/* 장르 */}
          <div>
            <label className="block font-semibold mb-1">장르</label>
            <select
              value={songs.genreId || ''}
              disabled
              className="w-full px-2 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none">
              <option value="">없음</option>
              {GENRES.map((g) => (
                <option key={g.id} value={g.id}>{g.label}</option>
              ))}
            </select>
          </div>

          {/* 디스크 */}
          <div>
            <label className="block font-semibold mb-1">디스크</label>
            <input
              type="text"
              value={songs.disc || ''}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
              readOnly
            />
          </div>

          {/* 트랙 */}
          <div>
            <label className="block font-semibold mb-1">트랙</label>
            <input
              type="text"
              value={songs.track || ''}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
              readOnly
            />
          </div>

          {/* 곡명 */}
          <div>
            <label className="block font-semibold mb-1">곡명</label>
            <input
              type="text"
              value={songs.nameKr || ''}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
              readOnly
            />
          </div>

          {/* 아티스트 */}
          <div>
            <label className="block font-semibold mb-1">곡 아티스트</label>
            <input
              type="text"
              value={songs.artistKr || ''}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
              readOnly
            />
          </div>

          {/* 작사 */}
          <div>
            <label className="block font-semibold mb-1">작사</label>
            <input
              type="text"
              value={songs.writerKr || ''}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
              readOnly
            />
          </div>

          {/* 작곡 */}
          <div>
            <label className="block font-semibold mb-1">작곡</label>
            <input
              type="text"
              value={songs.composerKr || ''}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
              readOnly
            />
          </div>

          {/* 편곡 */}
          <div>
            <label className="block font-semibold mb-1">편곡</label>
            <input
              type="text"
              value={songs.arrangerKr || ''}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
              readOnly
            />
          </div>

          {/* 코드 */}
          <div>
            <label className="block font-semibold mb-1">곡 코드</label>
            <input
              type="text"
              value={songs.code || ''}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
              readOnly
            />
          </div>

          {/* isrc */}
          <div>
            <label className="block font-semibold mb-1">isrc</label>
            <input
              type="text"
              value={songs.isrc || ''}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
              readOnly
            />
          </div>

          {/* uci */}
          <div>
            <label className="block font-semibold mb-1">uci</label>
            <input
              type="text"
              value={songs.uci || ''}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
              readOnly
            />
          </div>

          {/* 타이틀 */}
          <div>
            <label className="block font-semibold mb-1">타이틀여부</label>
            <div className="flex gap-6">
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="titleYn"
                  value="Y"
                  checked={songs.titleYn === 'Y'}
                  onChange={() => setSongs({ ...songs, titleYn: 'Y' })}
                  disabled={true}
                />
                <span>타이틀</span>
              </label>
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="titleYn"
                  value="N"
                  checked={songs.titleYn === 'N'}
                  onChange={() => setSongs({ ...songs, titleYn: 'N' })}
                  disabled={true}
                />
                <span>수록곡</span>
              </label>
            </div>
          </div>

          {/* 19금 */}
          <div>
            <label className="block font-semibold mb-1">19금여부</label>
            <div className="flex gap-6">
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  value="19금"
                  checked={songs.adultYn === 'Y'}
                  disabled={true}
                />
                <span>19금</span>
              </label>
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  value="전체"
                  checked={songs.adultYn === 'N'}
                  disabled={true}
                />
                <span>전체</span>
              </label>
            </div>
          </div>

          {/* 가사 */}
          {songs.lyrics && (
            <div>
              <label className="block font-semibold mb-1">가사</label>
              <div className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 whitespace-pre-wrap max-h-60 overflow-y-auto text-sm leading-relaxed">
                {songs.lyrics}
              </div>
            </div>
          )}
        </div>

        <div className="w-full flex justify-end items-center mt-5">
          <ButtonItem
            className="mr-2"
            text="목록"
            color="gray"
            onClick={() => {
              const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
              navigate(`/Songs?page=${page}${searchParam}`);
            }}
          />
          <ButtonItem
            className="mr-2"
            text="삭제"
            color="red"
            onClick={deletesong}
          />
          <ButtonItem
            text="수정"
            color="blue"
            onClick={() => {
              const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
              navigate(`/Song/Modify/${id}?page=${page}${searchParam}`);
            }}
          />
        </div>
    </>
  );
}

export default SongViewPage;
